function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9219 25.2118C23.9219 22.5202 25.0184 17.9346 31.0994 17.9346C35.9842 17.9346 37.8783 21.0249 37.8783 24.1153C37.8783 27.5047 36.3829 29.2991 30.5013 31.4922V36.9751",
  stroke: "currentcolor",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.7006 43.4548C31.6917 43.4548 32.495 42.6515 32.495 41.6604C32.495 40.6694 31.6917 39.866 30.7006 39.866C29.7096 39.866 28.9062 40.6694 28.9062 41.6604C28.9062 42.6515 29.7096 43.4548 30.7006 43.4548Z",
  fill: "currentcolor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M34.2894 2.08411C48.0464 3.9782 58.7131 15.8411 58.7131 30.1963C58.7131 45.8474 45.9529 58.6075 30.3018 58.6075C14.5511 58.6075 1.89062 45.8474 1.89062 30.1963C1.89062 14.5452 14.5511 1.78505 30.3018 1.78505",
  stroke: "#016D38",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0125 53.9221C15.3489 52.3271 6.37695 42.3583 6.37695 30.1963C6.37695 16.9377 17.0436 6.27103 30.3022 6.27103C43.5608 6.27103 54.2274 16.9377 54.2274 30.1963C54.2274 42.9564 44.1589 53.4237 31.5981 54.1215",
  stroke: "#FFDC5D",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.3be5b9f7.svg";
export { ForwardRef as ReactComponent };